import { TimeZones } from '@pelicargo/utils';

import { SimpleSelect, SimpleSelectProps } from '../SimpleSelect';

export const AirportTimezoneInput = (props: SimpleSelectProps) => (
  <SimpleSelect
    {...props}
    options={TimeZones.map((tz) => ({
      label: tz,
      value: tz,
    }))}
  />
);
